import React from 'react';
import classnames from 'classnames';
import { useTranslation } from 'react-i18next';
import { IconSize } from '@wix/da-ds/pkg/Icons/IconWrap';
import { useIsCurrentUserDeviationAuthor } from '../../../../../utils/hooks/useIsCurrentUserDeviationAuthor';
import { useDeviationAttributes } from '../../../../hooks/useDeviationAttributes';
import FaveButton from '../../../../../FaveButton';
import FavingIcon from '../../../../../FaveButton/FavingIcon';
import s from './FaveControl.scss';
var FaveControl = function (_a) {
    var deviation = _a.deviation, className = _a.className, iconClassName = _a.iconClassName, textClassName = _a.textClassName;
    var t = useTranslation().t;
    var isOwner = useIsCurrentUserDeviationAuthor(deviation);
    var isFavouritable = useDeviationAttributes(deviation, isOwner).isFavouritable;
    return isFavouritable ? (React.createElement(FaveButton, { className: classnames(s['root'], className), deviation: deviation, "aria-label": t('deviationview.overlay.a11y.favourite') }, function (_a) {
        var isFavourite = _a.isFavourite;
        return (React.createElement(React.Fragment, null,
            React.createElement(FavingIcon, { className: iconClassName, deviationId: deviation.deviationId, isFavourited: isFavourite, size: IconSize.MEDIUM, withPadding: false, disableDefaultColors: true, "aria-label": t('deviationview.overlay.a11y.favourite') }),
            React.createElement("span", { className: textClassName }, t(isFavourite
                ? 'actionbar.inFavourites'
                : 'actionbar.addToFavourites'))));
    })) : null;
};
FaveControl.displayName = 'FaveControl';
export default FaveControl;
//# sourceMappingURL=FaveControl.js.map